const enableReplaceAll = () => {
    if(!String.prototype.replaceAll) {
        String.prototype.replaceAll = function(search, replacement) {
            const str = this;
            return str.split(search).join(replacement);
        };
    }
}

export const inlcudePolyfills = () => {
    enableReplaceAll();
}